import { render, staticRenderFns } from "./AccountTypeColumnMenu.vue?vue&type=template&id=2f278664&"
import script from "./AccountTypeColumnMenu.vue?vue&type=script&lang=js&"
export * from "./AccountTypeColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports